import React from 'react';
import BottomSection from '../components/BottomSection';

type PlaceholderPageProps = {
  currentPath: string;
};

function PlaceholderPage({ currentPath }: PlaceholderPageProps) {
  return (
    <main className="placeholder-page">
      <div className="placeholder-content">
        <section className="placeholder-card">
          <h1>页面建设中</h1>
          <p>{currentPath} 正在整理内容，稍后补上。</p>
        </section>
      </div>

      <BottomSection />
    </main>
  );
}

export default PlaceholderPage;
